<template>
 <div class='promotionCenterMineCont'>
     <div>
        <div class="mineTitle">
            {{mineData && mineData.agentName}}   
        </div>

        
        <div class="cumulativeRevenueCont">
            <p class="cumulativeRevenueText">累计收益（元）</p>
            <p class="cumulativeRevenueMoney">
                <!-- <span>{{mineData && mineData.totalIncome}}</span> -->
                <span v-if="mineData && mineData.totalIncome.toString().split('.')[0]">
                    <img  v-for="(item,idx) in mineData  && mineData.totalIncome.toString().split('.')[0].split('')" :key="idx" :src="fontFormat(item,idx)"/>
 
                </span>
                 <span v-if="mineData  && mineData.totalIncome.toString().split('.')[1]">
                    <img src="../../../assets/images/agentManage/number_ponit.png"/>
                </span>
                <span v-if="mineData  && mineData.totalIncome.toString().split('.')[1]">
                    <img  v-for="(item1,idx1) in mineData  && mineData.totalIncome.toString().split('.')[1].split('')" :key="idx1" :src="fontFormat(item1,idx1)"/>
                </span>               
            </p>
            <p class="rengongjiesuanBtn" @click="seeShouyiHandle()">查看收益</p>
        </div>


        <div class="leijiCont">
            <div class="leijiContList">
                <p class="leijikehuNumber">
                    <span v-if="mineData && mineData.customerNum.toString().split('.')[0]">
                        <img  v-for="(item,idx) in mineData  && mineData.customerNum.toString().split('.')[0].split('')" :key="idx" :src="fontFormat(item,idx)"/>
                    </span>
                    <span v-if="mineData  && mineData.customerNum.toString().split('.')[1]">
                        <img src="../../../assets/images/agentManage/number_ponit.png"/>
                    </span>
                    <span v-if="mineData  && mineData.customerNum.toString().split('.')[1]">
                        <img  v-for="(item1,idx1) in mineData  &&  mineData.customerNum.toString().split('.')[1].split('')" :key="idx1" :src="fontFormat(item1,idx1)"/>
                    </span> 
                </p>
                <p class="leijikehuText">累计客户</p>

            </div>
            <div class="leijiContList">          
                <p class="leijikehuNumber">
                     <span v-if="mineData && mineData.orderNum.toString().split('.')[0]">
                        <img  v-for="(item,idx) in mineData  && mineData.orderNum.toString().split('.')[0].split('')" :key="idx" :src="fontFormat(item,idx)"/>
                    </span>
                    <span v-if="mineData  && mineData.orderNum.toString().split('.')[1]">
                        <img src="../../../assets/images/agentManage/number_ponit.png"/>
                    </span>
                    <span v-if="mineData  && mineData.orderNum.toString().split('.')[1]">
                        <img  v-for="(item1,idx1) in mineData  && mineData.orderNum.toString().split('.')[1].split('')" :key="idx1" :src="fontFormat(item1,idx1)"/>
                    </span>                    
                </p>
                <p class="leijikehuText">累计订单</p>
            </div>
            
        </div>

        <div class="mineTabListCont">
            <div class="mineTabList">
                <p class="minTabTitle">今日收益（元）</p>
                <p class="minTabNumber">+{{mineData && mineData.todayIncome}}</p>
            </div>


            <div class="mineTabList">
                <p class="minTabTitle">今日订单</p>
                <p class="minTabNumber">+{{mineData && mineData.todayOrderNum}}</p>
            </div>


            <div class="mineTabList">
                <p class="minTabTitle">今日新增客户</p>
                <p class="minTabNumber">+{{mineData && mineData.todayCustomerNum}}</p>
            </div>

        </div>
    </div>

    <Footer></Footer>
 </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant';
import Footer  from './footer';



export default {
    name: "promotionCenterMine",
    data () {
        return {
            mineData: null


        };
    },
    components: {
        Footer,
        
    },

    computed: {
        fontFormat() {
            return (item,idx) => {
                return require(`../../../assets/images/agentManage/${item}.png`)
            }
        }
    },

    created(){
         localStorage.setItem("currentPromationNav",'mine')
        
    },

    mounted(){
        this.getData()
        
       
    },
    destroyed(){
        
    },

    methods: {
        seeShouyiHandle() {
            this.$router.push({
                path: '/cumulativeRevenueList',
            }) 
        },
        
        getData(){
            this.$api.agentManage.findIncomeInfo({})
            .then(res=>{
                if (res.data) {
                    this.mineData = res.data    
                } else {
                    Toast({
                        message: res.message,
                        duration: 4000,
                    });

                }
            }).catch(error=> {
                console.log(error)
                Toast({
                    message: '网络异常,请稍后重试',
                    duration: 4000,
                });
            })
        }
       

       

       
    },



}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>

